import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const SERVER_URL = process.env.NEXT_PUBLIC_SERVER_URL;

if (!SERVER_URL) {
  throw new Error("NEXT_PUBLIC_SERVER_URL 환경변수가 설정되지 않았습니다.");
}

export interface CtlBranch {
  id: number;
  name: string;
  region: string;
  address: string;
  institution: string;
  linkUrl: string;
  imageUrl: string;
  latitude: number;
  longitude: number;
}

export interface CtlMapResponse {
  result: boolean;
  data: {
    total: number;
    list: CtlBranch[];
  };
}

const fetchCtlMap = async (): Promise<CtlMapResponse> => {
  const res = await axios.get<CtlMapResponse>(`${SERVER_URL}ctl/map`);
  return res.data;
};

export const useGetCtlMap = () => {
  return useQuery({
    queryKey: ["ctl-map"],
    queryFn: fetchCtlMap,
    staleTime: Infinity,
  });
};
